<div class="favorite-icon">
  <button (click)="toggleFavourite(course.courseRecordId, userId)">
    <fa-icon [icon]="course.favoriteIcon"></fa-icon>
  </button>
</div>
